import { PATHS } from '@ctcells/core'

import type { GroupTabDef } from '../groupTabs.ts'

/**
 * 「운영 › 작업」의 탭 2종 — **유일한 출처다.**
 *
 * 🔴 이력은 사이드바에 따로 있다가 2026-09-18 eric 지시로 「작업」 안으로 들어왔다
 *    ("작업 안에.. 이력 알람 다 포함시켜줘"). 항목을 되살리지 마라.
 * 🔴 **알람은 2026-09-22 eric 지시로 다시 나갔다**(「작업에서 알람탭을 따로 떼줘」) —
 *    지금은 **헤더의 제 문**(`NAV_GROUPS` 의 `alarms`)이다. `'alarms'` 를 여기 도로 넣지 마라.
 *    넣으면 같은 화면으로 가는 길이 둘이 되고, `useAlarmBadge.test.tsx`(배지가 붙는 자리) ·
 *    `groupTabRule.test.tsx`(무리 탭 이름) 가 걸린다.
 * ⚠ **모니터링은 합치지 않았다.**
 *
 * 🔴 **여기는 탭끼리 권한이 갈린다**(준비와 같고 관리와 같다). 서버가 `GET /batches` 는 전원에게
 *    열고(`views/batches.py` `require_roles(ROLES)`) `GET /history` 는 operator/admin 으로 막는다
 *    (`history.py PRIVILEGED_ROLES`). 그래서 문(헤더 「작업」)은 가장 약한 `monitor` 이고,
 *    이력 탭이 제 `view` 를 따로 건다 — 그래야 닿는 사람이 전후로 같다.
 * ⚠ 노출 판단 전용이다. 집행은 서버 403 `INSUFFICIENT_ROLE`.
 */
export type OpsTabId = 'batches' | 'history'

/** 순서 = 화면 표시 순서. 기본 진입은 첫 번째(`진행 중`)다 */
export const OPS_TABS: readonly GroupTabDef<OpsTabId>[] = [
  /*
   * 🔴 `view` → `monitor` (2026-09-21). `GET /batches`·`/batches/{id}` 는 서버가
   *    `require_roles(ROLES)` 로 **전원**에게 연다(`views/batches.py`) — viewer 도 200 이다.
   *    `view` 로 두면 viewer 가 **서버가 허락한 작업 목록**을 못 본다. 이력 탭은 `/history` 가
   *    실제로 operator/admin 이라 `view` 그대로다.
   */
  /*
   * 🔴 탭 이름은 `tab.ops.batches`(「진행 중」 · eric 2026-09-30). 제목(`screen.opsGroup.title` 「작업」) ·
   *    헤더 메뉴(`nav.item.batches` 「작업 관리」)와 **키를 가른다** — 셋은 각자 움직인다.
   */
  { id: 'batches', path: PATHS.batches, labelKey: 'tab.ops.batches', permission: 'monitor' },
  {
    id: 'history',
    path: PATHS.batchHistory,
    labelKey: 'nav.item.batchHistory',
    permission: 'view',
  },
]
